module.exports = __webpack_public_path__ + "static/gmail-f8bd757f58124a6f22b8d996b6b3d79b.png";